const ORGANIZATION_TYPES = {
  selfService: 'self-service',
  managedAccount: 'managed-account'
};

const ORGANIZATION_ROLES = {
  owner: 'owner',
  admin: 'admin',
  user: 'user'
};

const ORGANIZATION_ROLES_LIST = Object.keys(ORGANIZATION_ROLES);

const ORGANIZATION_PAYMENT_TYPE = {
  invoice: 'invoice',
  multi_cc: 'multi_cc',
  single_cc: 'single_cc'
};

const PENDING = 'pending';

const ORGANIZATION_STATUS = {
  [PENDING]: PENDING
};

export {
  ORGANIZATION_PAYMENT_TYPE,
  ORGANIZATION_ROLES,
  ORGANIZATION_ROLES_LIST,
  ORGANIZATION_STATUS,
  ORGANIZATION_TYPES
};
